/* template */
<template minapp="mpx" xlang="wxml"><div><div class="change-ticket-tip" v-if="(showChangeTips)">改签票需支付全价票款，原票票款扣除手续费后原路退回。</div><div class="bottom-action"><div class="money-container"><div v-for="(item, index) in (payInfo)" class="order-money"><div class="order-money-type" v-if="(studentLength > 0)">约</div><div :style="[(item.pay_style)] | transRpxStyle" class="order-money-type">￥</div><div :style="[(item.pay_style)] | transRpxStyle" class="order-money-num">{{ item.pay_price }}</div></div><div class="discount-area" v-if="(isShowCrossedPrice)"><div class="discount-desc" v-if="(discountInfo.discount_desc)">{{discountInfo.discount_desc}}</div><crossed-price :price="(Number(discountInfo.coupon_after_price))" class="original-price"/></div></div><div class="order-action-bottom"><mpx-view @tap="switchDealDetail" class="order-action-bottom-1" v-if="(showDealDetail)"><span>明细</span><div :class="(!showDealAlert  && 'rotate')" class="down-arrow"></div></mpx-view><template v-if="(isFromScramble & payType)"><mpx-view v-for="(item, index) in (scrambleButton)" :class="({'order-action-bottom-2':true, disabled:!canPay})" :style="[(item.extra.containerStyle)] | transRpxStyle" @tap="makeScramblePay(item)"><div :style="[(item.extra.textStyle)] | transRpxStyle">{{ item.extra.buttonText }}</div></mpx-view></template><template v-else><mpx-view :class="({'order-action-bottom-2':true,disabled:!canPay})" @tap="makePay"><div>{{ buttonCopyWritting }}</div><div class="button-coupon-desc" v-if="(buttonDesText)">{{buttonDesText}}</div></mpx-view></template></div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mc05e99a0"}'>
  .change-ticket-tip
    color $train-color-theme-blue
    font-size 12px
    font-weight 400
    background linear-gradient(-63deg, #fefefe 0%, #edf4ff 100%)
    padding 8px 12px
  .bottom-action
    width 100vw
    height 98px
    font-family PingFangSC
    padding 11px 14px 39px 16px !important
    background-color #ffffff
    box-sizing border-box
    display flex
    justify-content space-between
    .money-container
      margin-top 4px
    .discount-area
      display flex
      margin-top 4px
      align-items center
      .discount-desc
        font-family PingFangSC-Regular
        font-size 10px
        font-weight normal
        line-height 10px
        color #FF6400
        margin-right 4px
      .original-price
        font-family PingFangSC-Regular
        font-size 10px
        font-weight normal
        line-height 10px
        color #999
    .order-money
      line-height 32px
      display flex
      align-items flex-end
      color #FF6400
      .order-money-type
        font-family PingFangSC-Semibold
        font-size 16px
        line-height 16px
        transform translateY(-4px)
      .order-money-num
        font-family Barlow Semi Condensed
        font-size 32px
        font-weight 400
        &-personal
          color #FF7D41
      .order-money-warn
        margin-left 6px
        font-size 12px
        color #999
        font-family PingFangSC-Regular
    .order-action-bottom
      display flex
      justify-content space-between
      .order-action-bottom-1
        display flex
        height 48px
        line-height 48px
        text-align center
        color #666
        font-weight normal
        font-size 13px
        justify-content center
        align-items center
        margin-right 14px
        min-width 34px
        .down-arrow
          background url('https://dpubstatic.udache.com/static/dpubimg/ZYtJNbT6WhCj_kokty2zz.png')
          background-size cover
          background-repeat no-repeat
          width 6px
          height 3px
          margin-left 4px
          &.rotate
            transform rotate(180deg)
      .button-coupon-desc
        position absolute
        top -8px
        right -1.5px
        padding 2px 4px
        background #FF4343
        border 1.5px solid #fff
        font-family PingFangSC-Medium
        font-size 10px
        font-weight normal
        line-height 12px
        color #fff
        border-radius 10px 10px 0 10px
        position absolute
      .order-action-bottom-2
        position relative
        width 140px
        height 50px
        line-height 48px
        text-align center
        border-radius 8px
        background #ff6400
        color #ffffff
        font-family PingFangSC-Medium
        font-size 16px
        &.disabled
          opacity 0.3
        
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mc05e99a0"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./order-detail-pay-bottom-bar.mpx.js?isComponent&outputPath=components%2Forder-detail-pay-bottom-barc05e99a0%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./order-detail-pay-bottom-bar.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Forder-detail-pay-bottom-barc05e99a0%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mc05e99a0"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/order-detail-pay-bottom-barc05e99a0/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'order-inline-info':getComponent(require("../../../components/order-inline-info.mpx?isComponent&outputPath=components%2Forder-inline-infoaaf95858%2Findex")),'es-card-wrap1':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/card/card-wrap1.mpx?isComponent&outputPath=components%2Fcard-wrap120040920%2Findex")),'es-descriptions':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/descriptions/index.mpx?isComponent&outputPath=components%2Findexf02c563e%2Findex")),'crossed-price':getComponent(require("../../../components/crossed-price/index.mpx?isComponent&outputPath=components%2Findex1220e10f%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
